import { Scenario, ScenarioType, Steps } from '../state/interfaces'

import {
  emailAddressAlert,
  confirmAlert,
  thanksAlertMobile,
  thanksAlertInternet,
  startMobileAlert,
  startInternetAlert,
  provincesStepMobileAlert,
  postalCodeAlert,
  internetSpeedAlert,
  emailAddressFiberOpticAlert,
  addressLocationFiberOpticAlert,
  confirmFiberOpticAlert,
  confirmFiberOpticSignup,
} from './alert-steps'
import {
  buyOrBringPhoneMobileSearchEmail,
  chooseBrandsAndroidMobileSearchEmail,
  chooseBrandsMobileSearchEmail,
  chooseBrandsProprietaryMobileSearchEmail,
  choosePhoneCameraMobileSearchEmail,
  choosePhoneFromListMobileSearchEmail,
  choosePhoneMemoryMobileSearchEmail,
  choosePhoneOsMobileSearchEmail,
  choosePhoneSizeMobileSearchEmail,
  howManyCallingMinutesMobileSearchEmail,
  howMuchDataMobileSearchEmail,
} from './mobile-search-email-steps'

export const mobileAlertScenarioA: Scenario = {
  id: 'mobile-alert-a',
  initialStep: Steps.START_MOBILE_ALERT,
  type: ScenarioType.MOBILE_ALERT,
  version: '1',
  milestones: [
    startMobileAlert.id,
    provincesStepMobileAlert.id,
    howManyCallingMinutesMobileSearchEmail.id,
    howMuchDataMobileSearchEmail.id,
    buyOrBringPhoneMobileSearchEmail.id,
    choosePhoneOsMobileSearchEmail.id,
    chooseBrandsMobileSearchEmail.id,
    choosePhoneSizeMobileSearchEmail.id,
    choosePhoneCameraMobileSearchEmail.id,
    choosePhoneMemoryMobileSearchEmail.id,
    choosePhoneFromListMobileSearchEmail.id,
    emailAddressAlert.id,
    confirmAlert.id,
    thanksAlertMobile.id,
  ],
  steps: [
    startMobileAlert,
    provincesStepMobileAlert,
    howManyCallingMinutesMobileSearchEmail,
    howMuchDataMobileSearchEmail,
    buyOrBringPhoneMobileSearchEmail,
    choosePhoneOsMobileSearchEmail,
    chooseBrandsMobileSearchEmail,
    chooseBrandsAndroidMobileSearchEmail,
    chooseBrandsProprietaryMobileSearchEmail,
    choosePhoneSizeMobileSearchEmail,
    choosePhoneCameraMobileSearchEmail,
    choosePhoneMemoryMobileSearchEmail,
    choosePhoneFromListMobileSearchEmail,
    emailAddressAlert,
    confirmAlert,
    thanksAlertMobile,
  ],
}

export const internetAlertScenarioA: Scenario = {
  id: 'internet-alert-a',
  initialStep: Steps.START_INTERNET_ALERT,
  type: ScenarioType.INTERNET_ALERT,
  version: '1',
  milestones: [
    startInternetAlert.id,
    internetSpeedAlert.id,
    postalCodeAlert.id,
    emailAddressAlert.id,
    confirmAlert.id,
    thanksAlertInternet.id,
  ],
  steps: [
    startInternetAlert,
    internetSpeedAlert,
    postalCodeAlert,
    emailAddressAlert,
    confirmAlert,
    thanksAlertInternet,
  ],
}

export const internetFiberOpticAlertScenarioA: Scenario = {
  id: 'internet-fiber-optic-alert-a',
  initialStep: Steps.EMAIL_ADDRESS,
  type: ScenarioType.FIBER_OPTIC_ALERT,
  version: '1',
  milestones: [
    emailAddressFiberOpticAlert.id,
    addressLocationFiberOpticAlert.id,
    confirmFiberOpticAlert.id,
    confirmFiberOpticSignup.id,
  ],
  steps: [emailAddressFiberOpticAlert, addressLocationFiberOpticAlert, confirmFiberOpticAlert, confirmFiberOpticSignup],
}
